import '../style/hot-city.scss'
export default {
  functional: true,
  render(h, context) {
    const [$slots] = context.children
    const props = context.props
    if (!props.hotCity || !props.hotCity.length) {
      return null
    }
    const renderInner = () => {
      return props.hotCity.map(item => {
        return $slots.hotItem({
          item,
          type: 'hot-item'
        })
      })
    }
    const inner = renderInner()
    return <div class='kye-area-hot-city'>
      <span class='label'>热门城市</span>
      <div class='hot-wrap'>{ inner }</div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/components/hot-city.js